{
    "-2GfB": {
        "key": "-2GfB",
        "isDead": false,
        "position": {
            "x": 4,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "bow",
        "effects": {},
        "inventory": {
            "items": {}
        }
    }
}